<mat-toolbar class="subtitulo">Objetivo</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
        <form #formCadastro="ngForm">

                <div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

                        <!-- DADOS INICIAIS -->
                        <div fxLayout="column" fxFlex="45%">
                                <mat-toolbar class="titulopartes">Dados Iniciais</mat-toolbar>
                                <mat-form-field>
                                        <input #nome matInput maxlength="200" name="nome"
                                                placeholder="Nome do Objetivo:" [(ngModel)]="objetivo.nome" required>
                                        <mat-hint align="end">{{nome.value.length}} / 200</mat-hint>
                                </mat-form-field>
                        </div>

                    <div fxLayout="column" fxFlex="55%">
                        <mat-toolbar class="titulopartes">Descrição</mat-toolbar>
                        <mat-form-field>
                            <input #descricao matInput maxlength="2000" name="descricao"
                                   placeholder="Descrição:" [(ngModel)]="objetivo.descricao">
                            <mat-hint align="end">{{ descricao.value.length }} / 2000</mat-hint>
                        </mat-form-field>
                    </div>
                </div>

            <div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
                <div fxLayout="column" fxFlex="45%">
                    <mat-toolbar class="titulopartes">Data</mat-toolbar>
                   <div fxLayout="row" fxFlexFill  fxLayoutGap="20px">
                       <mat-form-field fxFlex="50">
                           <input matInput name="dtImplantacao" [matDatepicker]="dtImplantacao"
                                  placeholder="Data de Implatação" [(ngModel)]="objetivo.dataImplantacao"
                                  required (input)="onMascaraDataInput($event)">
                           <mat-datepicker-toggle matSuffix [for]="dtImplantacao"></mat-datepicker-toggle>
                           <mat-datepicker #dtImplantacao></mat-datepicker>
                       </mat-form-field>

                       <mat-form-field fxFlex="50">
                           <input matInput name="dtTermino" [matDatepicker]="dtTermino" placeholder="Data Término"
                                  [(ngModel)]="objetivo.dataTermino" (input)="onMascaraDataInput($event)">
                           <mat-datepicker-toggle matSuffix [for]="dtTermino"></mat-datepicker-toggle>
                           <mat-datepicker #dtTermino></mat-datepicker>
                       </mat-form-field>
                   </div>
                </div>

                <!-- PERSPECTIVA -->
                <div fxLayout="column" fxFlex="55%">
                    <mat-toolbar class="titulopartes">Perspectiva</mat-toolbar>
                    <mat-form-field>
                        <mat-label>Perspectivas:</mat-label>
                        <mat-select [(ngModel)]="objetivo.perspectiva.idPerspectiva" name="perspectiva"
                                    required>
                            <mat-option></mat-option>
                            <mat-option *ngFor="let i of perspectivas" [value]="i.idPerspectiva">
                                {{ i.nmPerspectiva }}
                            </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="perspectivas?.length === 0" align="start">Nenhuma perspectiva
                            cadastrada
                        </mat-hint>
                    </mat-form-field>
                </div>
            </div>




                <!-- BOTOES -->
                <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                        fxFlexFill>
                        <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button name="botaoConfirmar"
                                fxFlex="20%" color="primary" [disabled]="formCadastro.invalid" (click)="cadastrar()">
                                Cadastrar
                        </button>

                        <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button name="botaoConfirmar"
                                fxFlex="20%" color="primary" [disabled]="formCadastro.invalid" (click)="atualizar()">
                                Atualizar
                        </button>

                        <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
                                Limpar
                        </button>
                        <button mat-raised-button fxFlex="20%" (click)="cancelar()">
                                Cancelar
                        </button>

                </div>
        </form>


</div>